(function(){
  // Inject blog CTA styles globally
  var style=document.createElement('style');
  style.textContent='.lsp-blog-cta{margin:48px 0 32px;padding:32px;background:#f5efe6;border-radius:12px;border-left:4px solid #8c7419;text-align:center}.lsp-blog-cta__heading{font-size:1.4rem;font-weight:700;color:#5a3e00;margin:0 0 8px;display:block}.lsp-blog-cta__body{color:#555;margin:0 0 20px;line-height:1.6;display:block}.lsp-blog-cta__btn{display:inline-block;padding:14px 28px;background:#8c7419;color:#fff!important;text-decoration:none;border-radius:4px;font-weight:700;font-size:1rem}';
  document.head.appendChild(style);

  function toH2(h1){
    var h2=document.createElement('h2');
    Array.from(h1.attributes).forEach(function(a){h2.setAttribute(a.name,a.value);});
    h2.innerHTML=h1.innerHTML;
    h1.parentNode.replaceChild(h2,h1);
  }
  function applyA11y(){
    document.querySelectorAll('.__pf h1.pf-heading-1-h3').forEach(toH2);
    document.querySelectorAll('h1').forEach(function(h){if(!h.textContent.trim())h.setAttribute('aria-hidden','true');});
    document.querySelectorAll('.article-template__content h1:not(.article-template__title),.article-template__body h1').forEach(toH2);
    var hasH1=[...document.querySelectorAll('h1')].some(function(h){return h.getAttribute('aria-hidden')!=='true'&&h.textContent.trim();});
    if(!hasH1){
      var heroP=document.querySelector('.__pf .pf-11_ p.pf-text-1');
      if(heroP){
        var h1=document.createElement('h1');
        Array.from(heroP.attributes).forEach(function(a){h1.setAttribute(a.name,a.value);});
        h1.innerHTML=heroP.innerHTML;
        heroP.parentNode.replaceChild(h1,heroP);
      }
    }
    document.querySelectorAll('a[href*="instagram.com/p/"]').forEach(function(a,i){
      if(!a.getAttribute('aria-label'))a.setAttribute('aria-label','View Instagram photo '+(i+1)+' from Loveleen Sari Palace');
      var img=a.querySelector('img');
      if(img&&!img.alt)img.alt='Loveleen Sari Palace Instagram photo '+(i+1);
    });
    document.querySelectorAll('.pf-slider-nav').forEach(function(nav){
      nav.querySelectorAll('button').forEach(function(btn,i){
        if(!btn.getAttribute('aria-label'))btn.setAttribute('aria-label','Go to slide '+(i+1));
      });
    });
    var articleBody=document.querySelector('.article-template__content');
    if(articleBody&&!articleBody.querySelector('.lsp-blog-cta')){
      var cta=document.createElement('div');
      cta.className='lsp-blog-cta';
      cta.innerHTML='<span class="lsp-blog-cta__heading">Ready to find your outfit?</span><span class="lsp-blog-cta__body">Come try everything on at our Artesia showroom. Bring your wedding invite and we\'ll help you coordinate the perfect look — no guesswork.</span><a href="/pages/booking" class="lsp-blog-cta__btn">Book a Showroom Visit →</a>';
      articleBody.appendChild(cta);
    }
  }
  document.addEventListener('DOMContentLoaded',applyA11y);
  window.addEventListener('load',function(){setTimeout(applyA11y,800);});
  var obs=new MutationObserver(function(ms){if(ms.some(function(m){return m.addedNodes.length;}))applyA11y();});
  document.addEventListener('DOMContentLoaded',function(){obs.observe(document.body,{childList:true,subtree:true});setTimeout(function(){obs.disconnect();},6000);});
})();